// extracted by mini-css-extract-plugin
export default {"root":"error_message-module___root___a164359b","message":"error_message-module___message___daeff13a"};